
import { IRack, IRackComponent, IComponent } from 'src/types';
import Alert, { AlertTypes } from 'src/components/AlertDisplay';

export const componentToRackComponent = (c: IComponent): IRackComponent => {
  return Object.assign(c,
    {
      location: c.location,
      level: c.level || 1,
      components: [],
    }
  );
}

export const makeSortedComponents = (components: IComponent[]) => {
  console.log('makeSortedComponents: ' + JSON.stringify(components));

  function assignChildren(parent: IRackComponent, parts: IComponent[]) {
    const children = parts.filter(c => c.parentId == parent.componentId);
    parent.components.push(...children.map(c => componentToRackComponent(c)));
    remaining = remaining.filter(c => c.parentId != parent.componentId);
    parent.components.forEach((c: IRackComponent) => { remaining = assignChildren(c, remaining) });
    return remaining;
  }

  const topList = components.filter(c => c.parentId == undefined);
  if (!topList || topList.length != 1) {
    Alert(AlertTypes.ERROR, 'Rack tree does not have exactly one root');
    throw new Error('not exactly one root node for rack');
  }
  const top = componentToRackComponent(topList[0]);
  let remaining = components.filter(c => c.parentId != undefined);
  assignChildren(top, remaining);
  if (remaining.length != 0) {
    Alert(AlertTypes.ERROR, 'Rack tree has orphan nodes');
  }

  return top;
};

export const sortTree = (compTree: IRackComponent) => {
  if (!compTree) {
    return;
  }
  compTree.components.sort((a, b) => {
    if (a.location && a.location.ou) {
      if (b.location && b.location.ou) {
        if (a.location.ou == b.location.ou) {
          return a.location.column > b.location.column ? 1 : -1;
        }
        return a.location.ou < b.location.ou ? 1 : -1;
      }
      // a is set, b is not, sort b higher
      return 1;
    }
    // B is set and a is not, send b up the list.
    if (b.location && b.location.ou) {
      return -1;
    }
    // neither has a location, sort by number
    return a.partNumber < b.partNumber ? 1 : -1;
  });
}

export const getRackComponentsByType = (compTree: IRackComponent, targetType: string): IRackComponent[] => {
  const comps: IRackComponent[] = [];

  if (compTree.type == targetType) {
    comps.push(compTree)
  }
  for (const c of compTree.components) {
    comps.push(...getRackComponentsByType(c, targetType));
  }
  return comps;
}
